import React from "react";
import ButtonIcon from "../../../../../../../../components/buttons/ButtonIcon";
import { CleanIcon } from "../../../../../../../../components/buttons/IconButtons";
import DivContainerBody from "../../../../../../../../components/DivContainerBody";
import { ACCESS_DEPARTMENTS_TABS, SHIFT_RESOURCE, STEPS_CREATE_SHIFT_ACCESS } from "../../Model/Models";
import TabPanel from "../../../../../../../../components/ResourceAssignment/TabPanel";
import { AddShiftResourceApp } from "../../Functionality/AddShiftResourceApp";
import { AssignedShiftResourceApp } from "../../Functionality/AssignedShiftResourceApp";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Second shift access section: department Add/Assigned tab panel.
 */
const SectionAccessDepartments = ({
                                      id,
                                      handleClearStep,
                                      departments,
                                      setDepartments,
                                      selectDeleteDepartments,
                                      setSelectDeleteDepartments,
                                      searchElement,
                                      setSearchElement,
                                      modified,
                                      setModified,
                                      mainContainerClass
                                  }) => {
    return (
        <div className={"row mb-3"}>
            <div className='d-flex justify-content-end col-12 mb-2'>
                {(id === null || typeof id === 'undefined') &&
                <ButtonIcon
                    className='btn-clean-secondary-600'
                    id='btn_sadep_clean_departments'
                    Icon={CleanIcon}
                    title={'clear_instances'}
                    onClick={() => handleClearStep(STEPS_CREATE_SHIFT_ACCESS.ACCESS_DEPARTMENTS.INDEX)}
                    iconProps='btn-icon-svg-12px icon-color-general-00'
                />
                }
            </div>

            <div className={"col-12 mb-4"}>
                <TabPanel
                    resource={SHIFT_RESOURCE.DEPARTMENTS}
                    tabsConfig={ACCESS_DEPARTMENTS_TABS}
                    selected={departments}
                    setSelected={setDepartments}
                    selectForDelete={selectDeleteDepartments}
                    setSelectForDelete={setSelectDeleteDepartments}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    modified={modified}
                    setModified={setModified}
                    id={id}
                    deleteButtonId={'btn_sadep_delete'}
                    useAddApp={AddShiftResourceApp}
                    useAssignedApp={AssignedShiftResourceApp}
                    mainContainerClass={mainContainerClass}
                />
            </div>
        </div>
    );
}

export default SectionAccessDepartments
